import Dashboard from '../layouts/Dashboard/Dashboard.jsx';

var indexRoutes = [{ path: '/dashboard', name: 'Home', component: Dashboard }];

export default indexRoutes;
